/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import { Redirect, withRouter } from 'react-router-dom'

import {
  Warning,
  Spinner
} from '../components'

import {
  getNodeUrl
} from '../utils'

class ObjectRedirect extends React.Component {
  state = { redirectInProcess: true, error: false }

  componentDidMount() {
    getNodeUrl(this.props.match.params.id, true)
    .then(
      url => this.setState({ url, redirectInProcess: false }),
      error => this.setState({ error: true, redirectInProcess: false })
    )
    .catch(error => this.setState({ error: true, redirectInProcess: false }))
  }

  render() {
    let { redirectInProcess, url, error } = this.state

    if (redirectInProcess) {
      return (
        <div className='slds-m-around_xx-large'>
          <Spinner type='tail' className='slds-m-top_x-large' />
          <div className='slds-align_absolute-center u-font-size-large'>
            Redirecting...
          </div>
        </div>
      )
    }

    if (error) {
      return (
        <div className='slds-m-around_xx-large u-font-size-larger'>
          <Warning>Redirect error occurred.</Warning>
        </div>
      )
    }

    return <Redirect to={url} />
  }
}

export default withRouter(ObjectRedirect)



// WEBPACK FOOTER //
// ./src/containers/ObjectRedirect.js